export const OE_SAO_PAULO_PROGRAM = 'OE_SAO_PAULO';

export class CohortHelpers {
  static getMinutesInMs(minutes: number): number {
    return minutes * 60 * 1000;
  }

  static getHoursInMs(hours: number): number {
    return hours * 60 * 60 * 1000;
  }

  static getSecondsInMs(seconds: number): number {
    return seconds * 1000;
  }

  static getMinutesFromMs(ms: number): number {
    return Math.floor(ms / 1000 / 60) % 60;
  }

  static getHoursFromMs(ms: number): number {
    return Math.floor(ms / 1000 / 3600);
  }

  static getSecondsFromMs(ms: number): number {
    return Math.floor(ms / 1000) % 60;
  }

  static getMsToPollStart<T>(response: Array<T>, getValue: (item: T) => number, msPollStartBuffer: number): number {
    const msToClosestClass = CohortHelpers.getMinorValueInArray(response, getValue);
    return CohortHelpers.unsignValue(msToClosestClass - msPollStartBuffer);
  }

  static unsignValue(value: number): number {
    return Math.max(value, 0);
  }

  static getMinorValueInArray<T>(array: T[], getValue: (item: T) => number): number {
    return array.reduce((min, item) => Math.min(min, getValue(item)), Number.POSITIVE_INFINITY);
  }

  static isSaoPauloProgramStudent(productCategory: string): boolean {
    return productCategory === OE_SAO_PAULO_PROGRAM;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort.helpers.ts